import { NgModule } from '@angular/core';
import { KeepaliveSvc, NgIdleModule } from '@ng-idle/core';
import { Keepalive } from './keepalive';
export var NgIdleKeepaliveModule = (function () {
    function NgIdleKeepaliveModule() {
    }
    NgIdleKeepaliveModule.forRoot = function () {
        return {
            ngModule: NgIdleKeepaliveModule,
            providers: [Keepalive, { provide: KeepaliveSvc, useExisting: Keepalive }]
        };
    };
    NgIdleKeepaliveModule.decorators = [
        { type: NgModule, args: [{ imports: [NgIdleModule.forRoot()] },] },
    ];
    /** @nocollapse */
    NgIdleKeepaliveModule.ctorParameters = [];
    return NgIdleKeepaliveModule;
}());
//# sourceMappingURL=module.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@ng-idle/keepalive/src/module.js
// module id = 1282
// module chunks = 3